module.exports = __webpack_public_path__ + "static/media/tesi_handbike.c8dbb161.pdf";